// removed by extract-text-webpack-plugin
module.exports = {"searchesList":"_3SPSe6tjyIDOxRqZcn6Qs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedSearchesList/SavedSearchesList.scss
// module id = 1774
// module chunks = 0